export default __webpack_public_path__ + "static/media/flag-cz.2197394b.svg";